import type { Brand, BrandModel, Carrier, Customer, EmailGroup, Owner, TripRoute, TripStop, User, WorkType } from 'src/types'
import { acceptHMRUpdate, defineStore } from 'pinia'

export type Key = keyof State

interface State {
  brand_models: BrandModel[]
  brands: Brand[]
  carriers: Carrier[]
  customers: Customer[]
  email_groups: EmailGroup[]
  owners: Owner[]
  // tags: Tag[]
  trip_routes: TripRoute[]
  trip_stops: TripStop[]
  users: User[]
  work_types: WorkType[]
}

export const useApiStore = defineStore('api', () => {
  const finish = ref(false)

  const state = ref<State>({
    brand_models: [],
    brands: [],
    carriers: [],
    customers: [],
    email_groups: [],
    owners: [],
    // tags: [],
    trip_routes: [],
    trip_stops: [],
    users: [],
    work_types: [],
  })

  const keys = computed(() => Object.keys(state.value) as Key[])
  const getObj = (id: number | undefined, key: Key) => state.value[key].find(itm => itm.id === id)
  const exists = (id: number | undefined, key: Key) => state.value[key].some(itm => itm.id === id)
  const existsLabel = (label: string | undefined, key: Key) => state.value[key].some(itm => itm.label === label)
  const getObjLabel = (id: number | string | undefined, key: Key) => state.value[key].find(itm => itm.id === Number(id))?.label
  const forSelect = (key: Key) => state.value[key].map(itm => ({ ...itm, value: itm.id, label: itm.label }))
  const grab = (key: Key, ids: number[]) => state.value[key].filter(itm => ids.includes(itm.id))

  async function init() {
    finish.value = false
    await Promise.all(keys.value.map(key => reload(key)))
    finish.value = true
  }

  async function reload(key: Key) {
    const { data } = await api.get(key)
    state.value[key] = data
  }

  function clear() {
    for (const key of keys.value) state.value[key] = []
  }

  // function addItem(key: Key, item: ) {
  //   state.value[key].push(item)
  // }

  return {
    finish,
    state,

    forSelect,
    exists,
    existsLabel,
    getObj,
    getObjLabel,
    grab,

    init,
    clear,
    reload,
  }
})

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useApiStore, import.meta.hot))
